import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import styles from "./quote.module.css";
import InputField from "../../common/InputFieldWithDropDown/InputField";
import { quoteGeneration, getLrsQuote, addLrsQuote } from "../../api";
import { useMyContext } from "../../myContext";
import HeadWithSubHead from "../../common/HeadWithSubHead";
import { decimalAdjust, addCommasInPrice } from "../../utils";
import Stepper from "../Stepper/Stepper";
import IndiaImg from "../../public/assets/inflag.svg";
import CommonButton from "../CommonButton/CommonButton";
import CommonModal from "../../common/Modal/modal";
import InputFieldWithoutDropDown from "../../common/InputFieldWithoutDropDown";
import { currencyData, defaultCurrency } from "../../constant";
import TCSModal from "./TCSModal";

const allLabelVal = [
  {
    Head: "Forex Rate",
    Value: "--",
  },
  {
    Head: "Transfer Fee",
    Value: "--",
  },
  {
    Head: "Tax Collected at Source [TCS]",
    Value: "--",
  },
  {
    Head: "Goods and Service Tax",
    Value: "--",
  },
  // {
  //   Head: "Surge Charge",
  //   Value: "--",
  // },
  // {
  //   Head: "Additional Fees",
  //   Value: "--",
  // },
];

const Quote = ({ setQuoteSubmitted }) => {
  const [loader, setLoader] = useState(false);
  const [amountINR, setAmountINR] = useState("");
  const [labelValue, setLabelValue] = useState();
  const [showQuoteButton, setShowQuoteButton] = useState(false);
  const [confirmTransferLoader, setConfirmTransferLoader] = useState(false);
  const [amountDuringGetQuote, setAmountDuringGetQuote] = useState();
  const [accountDetail, setAccountDetail] = useState();
  const [RemitbankId, setRemitBankId] = useState("");
  const [StudentId, setStudentId] = useState("");
  const [BeneBankId, setBeneBankId] = useState("");
  const [purposeId, setPurposeId] = useState("");
  const [purpose, setPurpose] = useState("");
  const [AmountConversion, setAmountConversion] = useState("--");
  const { setTransactionId, isEducationLoanCheck, setUserStatus } =
    useMyContext("");
  const [disableButton, setDisableButton] = useState(false);
  const [amountExceedError, setAmountExceedError] = useState("");
  const [amountLimitedError, setAmountLimitedError] = useState("");
  const [showError, setShowError] = useState("");
  const [currency, setCurrency] = useState("");
  const [countryflag, setCountryFlag] = useState();
  const [subPurpose, setSubPurpose] = useState("");
  const inputE1 = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [showCoupon, setShowCoupon] = useState(false);
  const [changeOfValue, setChangeOfValue] = useState(false);
  const [showCouponText, setShowCouponText] = useState(false);
  const [differenceAfterCoupon, setDifferenceAfterCoupon] = useState(0);
  const [differenceValueToShow, setDifferenceValueToShow] = useState();
  const [olderValueBeforeCoupon, setOlderValueBeforeCoupon] = useState();
  const [couponErrorMessage, setCouponErrorMessage] = useState("");
  const [couponAppliedSuccessfully, setCouponAppliedSuccessfully] =
    useState(false);
  const [couponLoader, setCouponLoader] = useState(false);
  const [openTCSModal, setOpenTCSModal] = useState(false);
  const [tcsModalType, setTcsModalType] = useState("add");
  const [tcsSources, setTcsSources] = useState([]);
  const [allTcsSources, setAllTcsSources] = useState([]);
  const [tcsSubmitLoader, setTcsSubmitLoader] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLabelValue(allLabelVal);
    if (inputE1.current) {
      inputE1.current.focus();
    }
  }, [inputE1]);

  useEffect(() => {
    if (amountINR > 0) {
      setShowQuoteButton(false);
      const updatedVal = labelValue.map((item) => {
        switch (item.Head) {
          case "Transfer Fee":
            return {
              ...item,
              Value: "--",
            };
          case "Total Amount Conversion":
            return {
              ...item,
              Value: "--",
            };
          case "Forex Rate":
            return { ...item, Value: "--" };
          case "Tax Collected at Source [TCS]":
            return { ...item, Value: "--" };
          case "Goods and Service Tax":
            return { ...item, Value: "--" };
          case "Surge Charge":
            return { ...item, Value: "--" };
          case "Additional Fees":
            return { ...item, Value: "--" };
          default:
            return item;
        }
      });
      setAmountConversion("--");
      setLabelValue(updatedVal);
    }
    if (currency === defaultCurrency && amountINR > 25000) {
      setDisableButton(true);
      setAmountExceedError(`Bank transaction limit is 25,000 USD.`);
    } else {
      setDisableButton(false);
      setAmountExceedError("");
    }
  }, [amountINR]);

  useEffect(() => {
    setRemitBankId(sessionStorage.getItem("remitterBankId"));
    setStudentId(sessionStorage.getItem("studentId"));
    setBeneBankId(sessionStorage.getItem("beneficiaryBankId"));
    setPurposeId(sessionStorage.getItem("purposeId"));
    setPurpose(sessionStorage.getItem("purpose"));
    setSubPurpose(sessionStorage.getItem("subPurpose"));

    let country = sessionStorage.getItem("country");
    if (country !== "") {
      let countryStringinObject = JSON?.parse(country);
      if (sessionStorage.getItem("currencyCode") !== "") {
        setCurrency(sessionStorage.getItem("currencyCode"));
      } else {
        setCurrency(countryStringinObject?.currencyList[0]);
      }
      setCountryFlag(countryStringinObject.image);
    }
    let accountDetail = sessionStorage.getItem("accountDetail");
    if (accountDetail !== "") {
      let accountDetailStringInObject = JSON.parse(accountDetail);
      setAccountDetail({ ...accountDetailStringInObject });
    }
    fetchLrsQuoteData();
  }, []);

  const genrateQuote = (isApplied) => {
    setUserStatus("quote-generated");
    setLoader(true);
    setAmountDuringGetQuote(amountINR);
    getQuote(isApplied);
  };

  const inputAmount = (e) => {
    const inputValue = e.target.value;
    if (
      inputValue >= 0 &&
      inputValue.indexOf(".") === -1 &&
      inputValue.length <= 7
    ) {
      setAmountINR(inputValue);
    }
    if (inputValue.length !== amountINR.length) {
      setChangeOfValue(true);
      setShowCoupon(false);
      setShowCouponText(false);
      setDifferenceAfterCoupon(0);
      setCouponAppliedSuccessfully(false);
      setCoupon("");
    }
  };

  const getQuote = async (isApplied) => {
    setShowError("");
    setCouponErrorMessage();
    if (isApplied) {
      setCouponLoader(true);
    }
    try {
      const body = {
        amount: amountINR,
        fromCurrency: "INR",
        toCurrency: currency,
        bankId: RemitbankId,
        beneBankId: BeneBankId,
        studentId: StudentId,
        inputCurrency: currency,
        purposeId: purposeId,
        haveEducationLoan: sessionStorage.getItem("EducationLoan"),
        couponCode: coupon,
        referenceId: sessionStorage.getItem("referenceId"),
      };
      const res = await quoteGeneration(body);
      if (res.status === 200) {
        // setOpenModal(true);
        setCouponLoader(false);
        setLoader(false);
        setShowQuoteButton(true);
        setTransactionId(res.data.transactionId);
        sessionStorage.setItem("transactionID", res.data.transactionId);
        const updatedVal = labelValue.map((item) => {
          switch (item.Head) {
            case "Transfer Fee":
              return {
                ...item,
                Value: `${addCommasInPrice(
                  res.data.totalBankCharges +
                    res.data.handlecharge +
                    res.data.otherCharges,
                )}`,
              };
            case "Total Amount Conversion":
              return {
                ...item,
                Value: `$${addCommasInPrice(res.data.finalFromAmount)}`,
              };
            case "Forex Rate":
              return {
                ...item,
                Value: decimalAdjust("floor", res.data.exRate, -4),
              };
            case "Tax Collected at Source [TCS]":
              return { ...item, Value: `${addCommasInPrice(res.data.tcsAmt)}` };
            case "Goods and Service Tax":
              return { ...item, Value: `${addCommasInPrice(res.data.gstAmt)}` };
            case "Surge Charge":
              return {
                ...item,
                Value: `${addCommasInPrice(res.data.surgeCharge)}`,
              };
            case "Additional Fees":
              return { ...item, Value: `${addCommasInPrice(res.data.fees)}` };
            default:
              return item;
          }
        });
        if (!isApplied) {
          setOlderValueBeforeCoupon(res.data.finalFromAmount);
          setShowCouponText(true);
        } else {
          const FindDifference = Math.floor(
            olderValueBeforeCoupon - res.data.finalFromAmount,
          );
          setDifferenceAfterCoupon(FindDifference);
          setDifferenceValueToShow(addCommasInPrice(FindDifference, false));
          setCouponAppliedSuccessfully(true);
        }
        const conversionAmount = addCommasInPrice(
          res.data.finalFromAmount,
          false,
        );
        if (
          currency !== defaultCurrency &&
          res.data.finalFromAmount > 2000000
        ) {
          setAmountLimitedError("Bank transaction limit is 20L INR");
        } else {
          setAmountLimitedError("");
        }
        setAmountConversion(conversionAmount);
        setLabelValue(updatedVal);
        return true;
      } else {
        if (res?.data?.message === "Request failed with status code 400") {
          setShowError("Bank transaction limit is 20L INR");
          setShowQuoteButton(false);
        } else if (res?.data?.message === "Invalid coupon") {
          setCouponErrorMessage(res?.data?.message);
        } else {
          setShowError(res?.data?.message);
          setShowQuoteButton(false);
        }
        setLoader(false);
        setCouponLoader(false);
        return false;
      }
    } catch (err) {
      setLoader(false);
      setShowQuoteButton(false);
      setCouponLoader(false);
      return false;
    }
  };

  const initiateTransfer = async () => {
    setOpenModal(false);
    if (amountDuringGetQuote === amountINR) {
      setQuoteSubmitted(true);
      sessionStorage.setItem("AmountConversion", AmountConversion);
    } else {
      setConfirmTransferLoader(true);
      try {
        const success = await getQuote();
        if (success) {
          setQuoteSubmitted(true);
        } else {
          setQuoteSubmitted(false);
        }
      } catch (error) {
      } finally {
        setConfirmTransferLoader(false);
      }
    }
  };

  const handleToggleModal = () => {
    setOpenModal(false);
  };

  const addCoupon = (e) => {
    let x = e.target.value.replace(/[\s.,/';[\]{}=+\-_)(]/g, "");
    if (x.length < 20) {
      setCoupon(x);
    }
  };

  const applyCoupon = () => {
    genrateQuote(true);
  };

  const handleOpenTCSModal = async (type) => {
    setTcsModalType(type);
    // Fetch LRS quote data when opening the modal
    await fetchLrsQuoteData();
    // if (type === "add") {
    //   // Always start with one empty source in add mode
    //   setTcsSources([
    //     {
    //       id: Date.now(),
    //       amount: "",
    //       sourceType: "",
    //       referenceId: "",
    //     },
    //   ]);
    // }
    setOpenTCSModal(true);
  };

  const handleCloseTCSModal = () => {
    setOpenTCSModal(false);
  };

  const handleTCSSubmit = async (sources) => {
    if (tcsModalType === "add" && sources.length > 0) {
      try {
        setTcsSubmitLoader(true);
        const referenceId = sessionStorage.getItem("referenceId");

        // Send API request for each new source
        const promises = sources.map((source) => {
          const body = {
            amount: source.amountDeclared,
            source: source.sourceType,
            referenceId: referenceId,
            recordDate: source.recordDate,
          };
          return addLrsQuote(body);
        });

        // Wait for all API calls to complete
        const responses = await Promise.all(promises);

        // Check if all requests were successful
        const allSuccessful = responses.every(
          (response) => response && response.status === 200,
        );

        if (allSuccessful) {
          await fetchLrsQuoteData();
        } else {
          console.error("Some LRS Quote submissions failed:", responses);
        }
      } catch (error) {
        console.error("Error submitting LRS quote:", error);
      } finally {
        setTcsSubmitLoader(false);
      }
    } else if (tcsModalType === "view") {
      setOpenTCSModal(false);
    }
  };

  const handleRemoveTCSSource = (id) => {
    const updatedSources = allTcsSources.filter((source) => source.id !== id);
    setAllTcsSources(updatedSources);
    setTcsSources(updatedSources);
  };

  const fetchLrsQuoteData = async () => {
    try {
      const referenceId = sessionStorage.getItem("referenceId");
      if (referenceId) {
        const response = await getLrsQuote(referenceId);
        if (response && response.status === 200) {
          console.log("LRS Quote Data:", response.data);

          // Process and set the TCS sources from API response
          if (response.data && Array.isArray(response.data)) {
            // Map the API response to the expected source format
            const mappedSources = response.data.map((item, index) => ({
              id: item.id || Date.now() + index, // Use API id or generate unique id
              amountDeclared: item.amountDeclared || "",
              sourceType: item.source || "",
              referenceId: item.referenceId,
              recordDate: item.recordDate || "",
            }));

            // Update both state variables
            setAllTcsSources(mappedSources);
            setTcsSources(mappedSources);

            // If sources exist, set modal to view mode
            if (mappedSources.length > 0) {
              setTcsModalType("view");
            }
          }
        }
      }
    } catch (error) {
      console.error("Error fetching LRS quote:", error);
    }
  };

  return (
    <>
      <Stepper stepPercent={100} />
      <div className={styles.outermostContainer}>
        <HeadWithSubHead
          head="Transfer Money"
          subHead="Enter the amount you want to send to the beneficiary."
        />
        <Row className={styles.topConatiner}>
          <Col md={6} className={styles.detailcolumn}>
            <p
              className={styles.transferMoneySubHeading}
              style={{ marginBottom: "8px" }}
            >
              Transfer Purpose
            </p>
            <p className={styles.transferMoneyHeading}>
              {purpose !== "" ? purpose : purposeId !== "" ? purposeId : "--"} (
              {subPurpose})
            </p>
            {/* <hr/> */}
            <p
              className={styles.transferMoneySubHeading}
              style={{ marginBottom: "8px" }}
            >
              Student
            </p>
            <p className={styles.transferMoneyHeading}>
              Name -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.studentName !== ""
                  ? accountDetail?.studentName
                  : "--"}
              </span>
            </p>
            {/* <hr/> */}
            <p
              className={styles.transferMoneySubHeading}
              style={{ marginBottom: "8px" }}
            >
              Remitter
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Name -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.remitterName !== ""
                  ? accountDetail?.remitterName
                  : "--"}
              </span>
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Bank Name -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.remitterBank !== ""
                  ? accountDetail?.remitterBank
                  : "--"}
              </span>
            </p>
            <p className={styles.transferMoneyHeading}>
              Account Number -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.remitterAccount !== ""
                  ? accountDetail?.remitterAccount
                  : "--"}
              </span>
            </p>
            {/* <hr/> */}
            <p
              className={styles.transferMoneySubHeading}
              style={{ marginBottom: "8px" }}
            >
              Beneficiary
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Name -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.beneficaryName !== ""
                  ? accountDetail?.beneficaryName
                  : "--"}
              </span>
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Bank Name -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.beneficiaryBank !== ""
                  ? accountDetail?.beneficiaryBank
                  : "--"}
              </span>
            </p>
            <p className={styles.transferMoneyHeading}>
              Account Number -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.beneficiaryAccount !== ""
                  ? accountDetail?.beneficiaryAccount
                  : "--"}
              </span>
            </p>
          </Col>
          <Col md={6} className={styles.mainContainer}>
            <div className={styles.calculatorBox}>
              <p className={styles.transactionDetails}>Transaction Details</p>
              <Row>
                <InputField
                  label={"Enter Amount"}
                  conversionValueButton={currency}
                  image={`https://flagcdn.com/${currencyData[currency]?.countryCode}.svg`}
                  value={amountINR}
                  onChange={(e) => {
                    inputAmount(e);
                  }}
                  errorMessage={amountExceedError}
                  forwardedRef={inputE1}
                />
              </Row>
              {/* <ConversionRow data={labelValue} />; */}
              {labelValue &&
                labelValue.map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Row
                        className={`${styles.inputConversionRow} ${
                          data.Head === "Tax Collected at Source [TCS]"
                            ? styles.tcsRowBackground
                            : ""
                        }`}
                      >
                        <Col
                          className={styles.inputBoxHeading}
                          lg={7}
                          md={7}
                          sm={7}
                          xs={7}
                        >
                          {data.Head}
                          {/* {data.Head === "Transfer Fee" && (
                            <p className={styles.ServiceTaxText}>
                              (Applies to transactions after 3:00 PM)
                            </p>
                          )} */}
                          {/* {data.Head === "Goods and Service Tax" && (
                            <p className={styles.ServiceTaxText}>
                              (Applies to transactions after 3:00 PM)
                            </p>
                          )} */}
                          {data.Head === "Surge Charge" && (
                            <p className={styles.ServiceTaxText}>
                              (Applies to transactions after 3:00 PM)
                            </p>
                          )}

                          {data.Head === "Tax Collected at Source [TCS]" && (
                            <p
                              className={styles.addAdditionalSources}
                              onClick={() => handleOpenTCSModal("add")}
                            >
                              Add additional LRS transactions
                            </p>
                          )}
                        </Col>
                        <Col
                          className={styles.inputBoxValue}
                          lg={5}
                          md={5}
                          sm={5}
                          xs={5}
                        >
                          {data.Value}
                          {data.Head === "Tax Collected at Source [TCS]" &&
                            allTcsSources.length > 0 && (
                              <p
                                className={styles.addAdditionalSources}
                                style={{ color: "#005DD6", cursor: "pointer" }}
                                onClick={() => handleOpenTCSModal("add")}
                              >
                                {allTcsSources.length} Added
                              </p>
                            )}
                          {data.Head === "Forex Rate" && showCouponText && (
                            <p
                              className={styles.couponApplyText}
                              onClick={() =>
                                setShowCoupon(true, setShowCouponText(false))
                              }
                            >
                              Apply Coupon Code
                            </p>
                          )}
                        </Col>
                      </Row>
                      {couponAppliedSuccessfully &&
                      data.Head === "Forex Rate" &&
                      differenceAfterCoupon >= 0 ? (
                        <p className={styles.savedText}>
                          You saved{" "}
                          <span style={{ color: "#005DD6" }}>
                            {differenceValueToShow} INR
                          </span>{" "}
                          on this transaction
                        </p>
                      ) : (
                        data.Head === "Forex Rate" &&
                        showCoupon &&
                        differenceAfterCoupon >= 0 && (
                          <Row>
                            <Col
                              className={styles.inputBoxAdditional}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              style={{ marginTop: "10px" }}
                            >
                              <InputFieldWithoutDropDown
                                placeholder={`Enter Coupon`}
                                value={coupon}
                                onChange={(e) => addCoupon(e)}
                                applyCoupon={applyCoupon}
                                disabled={coupon.length > 0 ? false : true}
                                error={
                                  couponErrorMessage?.length > 0 ? true : false
                                }
                                loader={couponLoader}
                              />
                            </Col>
                            <span className={styles.InvalidCoponError}>
                              {couponErrorMessage}
                            </span>
                          </Row>
                        )
                      )}
                    </React.Fragment>
                  );
                })}
              <Row className="pt-3">
                <InputField
                  label={""}
                  conversionValueButton={"INR"}
                  disabled={true}
                  value={AmountConversion}
                  inputSize="quote"
                  image={IndiaImg}
                />
              </Row>
            </div>
            {showQuoteButton ? (
              <Row className={styles.ProceedButtton}>
                {amountLimitedError !== "" && (
                  <div className={styles.errorState}>{amountLimitedError}</div>
                )}
                <CommonButton
                  title="Confirm Transfer"
                  // onClick={() => setOpenModal(true)}
                  onClick={() => initiateTransfer()}
                  loading={loader}
                  disabled={
                    confirmTransferLoader ||
                    amountINR === "" ||
                    disableButton === true ||
                    amountLimitedError !== ""
                  }
                  width={"261px"}
                />
              </Row>
            ) : (
              <Row className={styles.ProceedButtton}>
                {showError !== "" ? (
                  <div className={styles.errorState}>{showError}</div>
                ) : (
                  ""
                )}
                <CommonButton
                  title="Get Quote"
                  onClick={() => genrateQuote(false)}
                  loading={loader}
                  disabled={
                    loader || amountINR === "" || disableButton === true
                  }
                  width={"261px"}
                />
              </Row>
            )}
          </Col>
        </Row>
        {/* <CommonModal
          isOpen={openModal}
          onRequestClose={handleToggleModal}
          initiateTransfer={initiateTransfer}
        /> */}
        <TCSModal
          isOpen={openTCSModal}
          onRequestClose={handleCloseTCSModal}
          sources={tcsSources}
          onSubmit={handleTCSSubmit}
          modalType={tcsModalType}
          setTcsModalType={setTcsModalType}
          allSources={allTcsSources}
          onRemoveSource={handleRemoveTCSSource}
          loading={tcsSubmitLoader}
        />
      </div>
    </>
  );
};

export default Quote;
